module.exports = __webpack_public_path__ + "static/media/PSTriangle.700e6792.svg";